import { getId } from '@milkdown/utils';
import { Mark, Node } from 'prosemirror-model';
import React from 'react';
import { createPortal } from 'react-dom';
import { Content, ReactNodeContainer } from './ReactNode';
export const createReactView = (addPortal, removePortalByKey) => (component) => (editor, _type, node, view, getPos, decorations) => new ReactNodeView(component, addPortal, removePortalByKey, editor, node, view, getPos, decorations);
export class ReactNodeView {
    constructor(component, addPortal, removePortalByKey, editor, node, view, getPos, decorations) {
        this.component = component;
        this.addPortal = addPortal;
        this.removePortalByKey = removePortalByKey;
        this.editor = editor;
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.decorations = decorations;
        const dom = document.createElement(node instanceof Mark ? 'span' : 'div');
        dom.classList.add('dom-wrapper');
        const contentDOM = node instanceof Node && node.isLeaf
            ? undefined
            : document.createElement(node instanceof Mark ? 'span' : 'div');
        if (contentDOM) {
            contentDOM.classList.add('content-dom');
            dom.appendChild(contentDOM);
        }
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.key = getId();
        this.renderPortal();
    }
    renderPortal() {
        if (!this.dom)
            return;
        const Component = this.component;
        const portal = createPortal(React.createElement(ReactNodeContainer, { editor: this.editor, node: this.node, view: this.view, getPos: this.getPos, decorations: this.decorations },
            React.createElement(Component, null,
                React.createElement(Content, { isMark: this.node instanceof Mark, dom: this.contentDOM }))), this.dom, this.key);
        this.addPortal(portal);
    }
    destroy() {
        this.dom = undefined;
        this.contentDOM = undefined;
        this.removePortalByKey(this.key);
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) {
            return true;
        }
        return !this.contentDOM.contains(mutation.target);
    }
}
//# sourceMappingURL=ReactNodeView.js.map